import type { AppConfig } from '@core/app-config';

export const environment: AppConfig = {
  apiBaseUrl: 'https://testing-api.search8.dev/api/v1',
  mediaBaseUrl: 'https://testing-cdn.search8.dev',
};
